import React, { useEffect } from 'react';
import classNames from 'classnames';
import ProgressBar from '@/components/vertical-slider/progress-bar';

function SliderItem({ isActiveItem, heading, body, itemClicked, duration, nextItem, autoplay }) {
	const totalTimeoutTime = autoplay ? duration : 0.4;
	const totalAnimationTime = autoplay && isActiveItem ? duration : 0.4;

	let animationClass;
	if (isActiveItem && autoplay) {
		animationClass = 'animate-progress-down-linear';
	} else if (isActiveItem && autoplay === false) {
		animationClass = 'animate-progress-down';
	} else {
		animationClass = 'animate-progress-up';
	}

	const onKeyUpHandler = e => {
		if (e.keyCode === 13) {
			itemClicked();
		}
	};

	useEffect(() => {
		const timer = setTimeout(() => {
			if (autoplay) {
				nextItem();
			}
		}, totalTimeoutTime * 1000);
		return () => clearTimeout(timer);
	}, [isActiveItem, autoplay, totalTimeoutTime, nextItem]);

	return (
		<div
			tabIndex="0"
			role="button"
			aria-pressed="false"
			className="flex mt-10"
			onClick={itemClicked}
			onKeyUp={onKeyUpHandler}
		>
			<div>
				<ProgressBar duration={totalAnimationTime} animationClass={animationClass} vertical={true} />
			</div>
			<div className="ml-4 cursor-pointer">
				<h3
					className={classNames(
						isActiveItem ? 'text-mariner' : 'text-midnight',
						'bold text-lg 2xl:text-xl 3xl:text-2xl  font-bold mb-3 duration-100'
					)}
				>
					{heading}
				</h3>
				<p className="2xl:text-[1.125rem] 3xl:text-[1.25rem] 2xl:leading-[1.6875rem] 3xl:leading-[1.875rem]">{body}</p>
			</div>
		</div>
	);
}

export default SliderItem;
